module.exports = __webpack_public_path__ + "img/lu.9fc5ef7c.svg";